import React from "react";
import Navbar from "../../Shared/NavBar/Navbar";
import Profile2MainContent from "./Components/Profile2MainContent";

const Profile2 = () => {
  return (
    <div className=" main-wrapper">
      <Navbar />
      <Profile2MainContent />
    </div>
  );
};

export default Profile2;
